<template>
  <div>
  <el-table
    :data="tableData"
    class="boxtable"
    :header-cell-style="handerMethod"
    :span-method="objectSpanMethod"
    :cell-style="cellStyle"
    :cell-class-name="cellClassStyle"
    style="width: 90%;"
  >

    <el-table-column height="20px">
      <template slot="header" slot-scope="scope">
        <div class="slotBox">
          <div>
            <p></p>
            <p>已选</p>
          </div>
          <div>
            <p></p>
            <p>未选</p>
          </div>
        </div>
      </template>
      <el-table-column prop="date" label="周/时" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.date" style="height: 100%">
            {{ scope.row.date }}
          </div>
          <div class="timeBox" v-else>
            <div class="timeTop">
              <span>已选择时间段</span>
              <span>
                <el-button type="text" @click="fortable(true)">清空</el-button>
              </span>
            </div>
            <ul>
              <li v-if="dataFrom.monday">
                <p>星期一</p>
                <p>{{ dataFrom.monday }}</p>
              </li>
              <li v-if="dataFrom.tuesday">
                <p>星期二</p>
                <p>{{ dataFrom.tuesday }}</p>
              </li>
              <li v-if="dataFrom.wednesday">
                <p>星期三</p>
                <p>{{ dataFrom.wednesday }}</p>
              </li>
              <li v-if="dataFrom.thursday">
                <p>星期四</p>
                <p>{{ dataFrom.thursday }}</p>
              </li>
              <li v-if="dataFrom.friday">
                <p>星期五</p>
                <p>{{ dataFrom.friday }}</p>
              </li>
              <li v-if="dataFrom.saturday">
                <p>星期六</p>
                <p>{{ dataFrom.saturday }}</p>
              </li>
              <li v-if="dataFrom.sunday">
                <p>星期日</p>
                <p>{{ dataFrom.sunday }}</p>
              </li>
            </ul>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="120" align="center">
        <template slot="header" slot-scope="scope">
          <div class="dateLeft">
            <p>00:30 - 12:00</p>
          </div>
        </template>
        <el-table-column
          v-for="(item, index) in tableData1"
          :key="item.key"
          :prop="item.key + ''"
          :label="item.label + ''"
          align="center"
          width="30px"
          class="boder"
        >
          <template slot-scope="scope">
            <div
              :class="{ active: scope.row[item.key].istrue ? true : false , bc: item.key == 'time0' ? true : false}"
              
              @click="getItemData(scope.row, item.key)"
              style="height: 100%"
            > 
              <p style="opacity: 0">1</p>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="dateRight" align="center">
        <template slot="header" slot-scope="scope">
          <div class="dateLeft">
            <p>12:00 - 23:30</p>
          </div>
        </template>
        <el-table-column
          v-for="(item, index) in tableData2"
          :key="item.key"
          :prop="item.key + ''"
          :label="item.label + ''"
          align="center"
          width="30px"
        >
          <template slot-scope="scope">
            <div
            :class="{ active: scope.row[item.key].istrue ? true : false , bc: item.key == 'time47' ? true : false}"
              @click="getItemData(scope.row, item.key)"
              style="height: 100%"
            >
           
              <p style="opacity: 0">1</p>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table-column>
  </el-table>
  <el-input  v-model="val" placeholder="" style="display: none;" ></el-input>
</div>
</template>
  
  <script>
import { analyzeTime } from "../../utils/tools";
export default {
  props:['value'],
  data() {
    return {
      tableData1: [],
      tableData2: [],
      tableData: [
        {
          date: "星期一",
        },

        {
          date: "星期二",
         
        },
        {
          date: "星期三",
        
        },
        {
          date: "星期四",
          dateLeft: "",
          dateRight: "",
        },
        {
          date: "星期五",
          
        },
        {
          date: "星期六",
        
        },
        {
          date: "星期日",
        },
        {},
      ],
      val: this.value,
      dataFrom: {
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
        sunday: "",
      },
      keyList: [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ],
    };
  },
  
  mounted() {
    this.fortable();
    this.calculateTime()
    // this.fortable();
    // this.getItemData()
    this.tableData1 = this.getMapTableList(0, 24);
    this.tableData2 = this.getMapTableList(24, 48);
    this.$nextTick(() => {
      document.querySelectorAll(".cell").forEach((item) => {
        item.style.padding = 0;
      });
    });
  },
 
  watch: {
    tableData: {
      // 时间改变
      handler(val) {
        this.calculateTime()
       
      },
      deep: true,
      // immediate: true,
    },
    value(val){
      this.val = val
      
    },
  },
  methods: {
    // 时间计算
    calculateTime(){
      this.val = ''
        this.tableData.forEach((item, index) => {
          if(index == 7) return;
          let arr = [];
          for (let i = 0; i < 48; i++) {
            arr.push(this.tableData[index]["time" + i]);
          }
          arr.push({ time: "00:00", istrue: false });
        
          this.val += analyzeTime(arr);
          this.dataFrom[this.keyList[index]] = analyzeTime(arr);
        });
        // console.log(this.val)
        this.$emit('input',this.val)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 7) {
        return {
          rowspan: 1,
          colspan: 49,
        };
      }
    },
    cellClassStyle({ row, column, rowIndex, columnIndex }){
      
      if(rowIndex < 7 && (columnIndex > 16 && columnIndex < 36) ){
        return 'z-border'
      }
    },
    cellStyle({row,column}) {
      // console.log(column)
      // console.log(row,'row')
      // if(row.errTitle.includes(column.label)){
      //    return "border:1px solid red;text-align:center"    
      // }else{
      //   return "color:green;text-align:center"  
      // }
    },
  init(list){
    this.tableData = list
  },
    getItemData(v, key) {
      console.log(v,key)
      if(key == 'time0' || key == 'time47') return;
      let n = this.tableData.findIndex((item) => item.date == v.date);
      let flag;
      flag = !v[key].istrue;

      if (v[key].label > 7 && v[key].label < 18) {
        if (!flag) {
          for (let i = 0; i < 48; i++) {
            this.$set(this.tableData, n, {
              ...this.tableData[n],
              ["time" + i]: { ...this.tableData[n]["time" + i], istrue: flag },
            });
          }
        }
         else {
          for (let i = 16; i < 36; i++) {
            console.log(this.tableData[n][key], "time" + i);
            this.$set(this.tableData, n, {
              ...this.tableData[n],
              ["time" + i]: {
                ...this.tableData[n]["time" + i],
                istrue: flag,
              },
            });
          }
        }

        console.log(this.tableData[n]);
      } else {
        console.log(1312321);
        this.$nextTick(() => {
          if(flag){
              for (let i = 16; i < 36; i++) {
            
              this.$set(this.tableData, n, {
                ...this.tableData[n],
                ["time" + i]: {
                  ...this.tableData[n]["time" + i],
                  istrue: flag,
                },
              });
            }
          }
          this.$set(this.tableData, n, {
            ...this.tableData[n],
            [key]: { ...this.tableData[n][key], istrue: flag },
          });
        });
      }

      // console.log(this.tableData[n]);
    },
   
    getMapTableList(s, v) {
      let obj = {};
      let list = [];
      for (let i = s; i < v; i++) {
        obj["time" + i] = {
          time: i % 2 != 0 ? 1 : 0,
          istrue: true,
          label: Math.floor(i / 2),
          key: "time" + i,
        };
      }

      for (let key in obj) {
        // console.log(key)
        list.push(obj[key]);
      }
      return list;
    },
    fortable(v = false) {
      this.tableData = this.tableData.map((item, index) => {
        let obj = {};
        for (let i = 0; i < 48; i++) {
          let hour = Math.floor(i / 2)
            .toString()
            .padStart(2, "0"); // 计算小时值
          let minute = i % 2 === 0 ? "00" : "30"; // 计算分钟值
          // console.log(hour + ":" + minute); // 输出时间
          obj["time" + i] = {
            time: hour + ":" + minute,
            istrue: v ? false : i > 15 && i < 18 * 2,
            label: Math.floor(i / 2),
          };
        }

        return {
          ...item,
          ...obj,
        };
      });
      // console.log( this.tableData,' this.tableData')
    },
  
    handerMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(row[0].level , columnIndex)
      if (row[0].level == 3) {
        for (let i = 0; i < 48; i++) {
          if (i % 2 == 0) {
            // console.log(i,'1')
            row[i].colSpan = 0;
          } else {
            // console.log(i,'2')
            row[i].colSpan = 2;
          }
        }
        if (columnIndex % 2 == 0) {
          return { display: "none" };
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.boxtable {
  --wcolor: rgba(41, 85, 228, 1);
  .slotBox {
    display: flex;
    > div {
      display: flex;
      align-items: center;
      margin-left: 10px;
      & P:nth-child(1) {
        width: 20px;
        height: 8px;
        border: 0.5px solid #ccc;
        border-radius: 4px;
      }
    }
    & div:nth-child(1) {
      & P:nth-child(1) {
        background: var(--wcolor);
      }
    }
  }

  //   .el-table .cell{
  //     padding: 0;
  //   }
  .active {
    background: var(--wcolor);
  }
}
::v-deep .el-table .cell,::v-deep .el-table td {
  padding: 0;
}
.timeBox {
  text-align: left;
  height: 100%;
  padding-left: 10px;
  > ul li {
    display: flex;
    > P {
      margin-left: 10px;
    }
  }
}
::v-deep .el-form-item__content {
  line-height: 0px;
}
.bc{
  background: #ccc !important;
}
.timeTop{
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
   span{
    margin: 0 10px;
  }
  
}
.boder{
  border: none;
}
::v-deep .z-border{
  border-right: none;
  // background: red;
}
</style>